import { useSignal } from "@preact/signals-react"

export default function useDateTable() {
	const showDateTable = useSignal(false)

	const setShowDateTable = value => {
		showDateTable.value = value.target.checked
	}

	return {
		showDateTable: showDateTable.value,
		setShowDateTable,
	}
}